import $ from '../core/Dom';
import ShopifyUtil from '../lib/ShopifyUtil';
import Dispatch from '../core/Dispatch';
import { CART_UPDATE } from '../lib/events';

export default (el, props) => {
    const form = $(el);
    const inputs = form.find('input');
    const submit = form.find('[data-submit]');
    const numberOfOptions = form.find('[data-options]').length;
    const variantIdField = form.find('[data-variant]');

    const findVariant = options => {
        if (Object.keys(options).length !== numberOfOptions) {
            return null;
        }

        const selectedVariant = props.variants.filter(variant => variant.selectedOptions.map(option => option.value).join(',') === Object.values(options).join(','));

        if (selectedVariant.length) {
            return selectedVariant[0];
        }

        return null;
    };

    const onUpdate = e => {
        console.log('onUpdate');
        const selectedOptions = {};
        inputs.each(node => {
            if (node.checked) {
                const input = $(node);
                selectedOptions[input.data('position')] = input.val();
            }
        });
        const variant = findVariant(selectedOptions);
        if (variant) {
            variantIdField.get(0).value = variant.id;
            submit.attr('disabled', null);
        } else {
            variantIdField.get(0).value = '';
            submit.attr('disabled', '');
        }
        console.log(variant);
    };

    const onShopifyUpdate = cart => {
        console.log('onShopifyUpdate', cart);
        Dispatch.emit(CART_UPDATE, cart);
    };

    const onSubmit = e => {
        console.log('onSubmit');
        e.preventDefault();
        const client = ShopifyUtil.getClient();
        ShopifyUtil.getCheckout(client, checkout => {
            client.checkout.addLineItems(checkout.id, [
                {
                    variantId: variantIdField.val(),
                    quantity: 1
                }
            ]).then(onShopifyUpdate);
        });
    };

    const init = () => {
        console.log(props);
        form.on('submit', onSubmit);
        inputs.on('change', onUpdate);
    };

    const destroy = () => {
        form.off('submit', onSubmit);
        inputs.off('change', onUpdate);
    };

    return {
        init,
        destroy
    };
};
